import BgPrice from "./bg-price.png";

const images = {    
  BgPrice,
};

export default images;